<template>
	<div :style="{ 'top': this.isTranslateBarOpen ? '40px' : '0px' }" class="modal is-active" ref="modal" role="dialog" tabindex="-1" aria-modal="true" aria-label="compare" aria-describedby="compare-description">

		<header class="modal-navbar">
      <div class="container">
        <i class="fas fa-arrow-circle-left fa-2x modal-btn-close" aria-label="close" @click="close"></i>
        <h1>Compare</h1>
      </div>
    </header>

    <div class="sr-only">
    	<p id="compare-description">{{`Comparing statistics and features of ${s1.name} and ${s2.name}`}}</p>
    	<cmps-aria-table-pqs
    		:s1Name="`${s1.name}`"
    		:s2Name="`${s2.name}`"
    		:s1Data="s1.data.qualityServiceData[0]"
    		:s2Data="s2.data.qualityServiceData[0]">
    	</cmps-aria-table-pqs>
    	<!-- <cmps-aria-table-letter-grade
    		:s1Name="`${s1.name}`"
    		:s2Name="`${s2.name}`"
    		:s1Data="s1Data.getLetterGradeData('2016-2017')"
    		:s2Data="s2Data.getLetterGradeData('2016-2017')">
    	</cmps-aria-table-letter-grade> -->
    	<cmps-aria-table-az-merit
    		:s1Name="`${s1.name}`"
    		:s2Name="`${s2.name}`"
    		:s1Data="s1.data.azMeritPassing[0]"
    		:s2Data="s2.data.azMeritPassing[0]">
    	</cmps-aria-table-az-merit>
    	<cmps-aria-table-sat
    		:s1Name="`${s1.name}`"
    		:s2Name="`${s2.name}`"
    		:s1ela="getSatElaAverage(s1)"
    		:s2ela="getSatElaAverage(s2)"
    		:s1math="getSatMathAverage(s1)"
    		:s2math="getSatMathAverage(s2)">
    	</cmps-aria-table-sat>
    	<cmps-aria-table-act
    		:s1Name="`${s1.name}`"
    		:s2Name="`${s2.name}`"
    		:s1Data="getActAverage(s1)"
    		:s2Data="getActAverage(s2)">
    	</cmps-aria-table-act>
    	<cmps-aria-table-features
    		:s1Name="`${s1.name}`"
    		:s2Name="`${s2.name}`"
    		:s1Features="s1.features"
    		:s2Features="s2.features"
    		:categories="categories">
    	</cmps-aria-table-features>
    </div>

		<div class="container" aria-hidden="true">

			<div class="headings notranslate" ref="header">
				<div class="columns is-mobile">
					<div class="column is-5-tablet is-6-mobile" >
						<div class="flexbox" :style="{ backgroundColor: s1.color }">
							<img v-if="s1.activeLogoImage" :src="s1.imagesPath + '/logos/' + s1.activeLogoImage.name" :alt="s1.activeLogoImage.alt_text" :height="80" :width="80">
              <img v-else height="80px" width="80px" :src="`/images/default/logo-placeholder.png`" :alt="'Placeholder logo image'">
							<div class="school-title">
								<h1>{{ s1.name }}</h1>
							</div>
						</div>
					</div>
					<div class="column is-5-tablet is-offset-2-tablet is-6-mobile is-offset-0-mobile">
						<div class="flexbox" :style="{ backgroundColor: s2.color }">
							<img v-if="s2.activeLogoImage" :src="s2.imagesPath + '/logos/' + s2.activeLogoImage.name" :alt="s2.activeLogoImage.alt_text" :height="80" :width="80">
              <img v-else height="80px" width="80px" :src="`/images/default/logo-placeholder.png`" :alt="'Placeholder logo image'">
							<div class="school-title">
								<h1>{{ s2.name }}</h1>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="statistics" ref="statistics">
				<header>
					<h3>Statistics</h3>
				</header>
				<div class="columns is-mobile">
					<div class="column is-5-tablet is-6-mobile" v-if="s1.data">
						<div class="stats-column" :style="{backgroundColor: this.s1ColorTint}">
							<div class="statistics-block" v-if="s1.data.qualityServiceData[0]">
								<h4><span>Parent Quality Service Ratings</span><span>{{ s1.data.qualityServiceData[0].school_year }}</span></h4>
								<cmps-progress-bar value="a_plus" type="parentqs" label="A+" :data="s1.data.qualityServiceData[0]" ></cmps-progress-bar>
								<cmps-progress-bar value="a" type="parentqs" label="A" :data="s1.data.qualityServiceData[0]" ></cmps-progress-bar>
								<cmps-progress-bar value="b" type="parentqs" label="B" :data="s1.data.qualityServiceData[0]" ></cmps-progress-bar>
							</div>
							<!-- <div class="statistics-block">
								<h4><span>Letter Grade</span><span>2016-2017</span></h4>
								<cmps-progress-bar value="grade" type="lettergrade" :data="s1Data.getLetterGradeData('2016-2017')" ></cmps-progress-bar>
							</div> -->
							<div class="statistics-block" v-if="s1.data.azMeritPassing[0]">
								<h4><span>AZ Merit % Passing</span><span>{{ s1.data.azMeritPassing[0].school_year }}</span></h4>
                <cmps-progress-bar value="passing_MAT" type="azmerit" label="Math" :data="s1.data.azMeritPassing[0]" ></cmps-progress-bar>
								<cmps-progress-bar value="passing_ELA" type="azmerit" label="ELA" :data="s1.data.azMeritPassing[0]" ></cmps-progress-bar>
							</div>
							<div class="statistics-block" v-if="s1.types.includes('high_school')">
								<h4><span>SAT Scores</span><span>4 year average</span></h4>
								<cmps-progress-bar value="mathAvg" type="sat" label="Math" :avg="getSatMathAverage(s1)" :data="getSatMathAverage(s1)"></cmps-progress-bar>
								<cmps-progress-bar value="elaAvg" type="sat" label="ELA" :avg="getSatElaAverage(s1)" :data="getSatElaAverage(s1)"></cmps-progress-bar>
							</div>
							<div class="statistics-block" v-if="s1.types.includes('high_school')">
								<h4><span>ACT Average Composite Score</span><span>{{ s1.data.actScores.length }} year average</span></h4>
								<cmps-progress-bar value="avg" type="act" label="Avg Score" :avg="getActAverage(s1)" :data="getActAverage(s1)"></cmps-progress-bar>
							</div>
						</div>
					</div>
					<div class="column is-5-tablet is-offset-2-tablet is-6-mobile is-offset-0-mobile" v-if="s2.data">
						<div class="stats-column" :style="{backgroundColor: this.s2ColorTint}">
							<div class="statistics-block" v-if="s2.data.qualityServiceData[0]">
								<h4><span>Parent Quality Service Ratings</span><span>{{ s2.data.qualityServiceData[0].school_year }}</span></h4>
								<cmps-progress-bar value="a_plus" type="parentqs" label="A+" :data="s2.data.qualityServiceData[0]" ></cmps-progress-bar>
								<cmps-progress-bar value="a" type="parentqs" label="A" :data="s2.data.qualityServiceData[0]" ></cmps-progress-bar>
								<cmps-progress-bar value="b" type="parentqs" label="B" :data="s2.data.qualityServiceData[0]" ></cmps-progress-bar>
							</div>
							<!-- <div class="statistics-block">
								<h4><span>Letter Grade</span><span>2016-2017</span></h4>
								<cmps-progress-bar value="grade" type="lettergrade" :data="s2Data.getLetterGradeData('2016-2017')" ></cmps-progress-bar>
							</div> -->
							<div class="statistics-block" v-if="s2.data.azMeritPassing[0]">
								<h4><span>AZ Merit % Passing</span><span>{{ s2.data.azMeritPassing[0].school_year }}</span></h4>
                <cmps-progress-bar value="passing_MAT" type="azmerit" label="Math" :data="s2.data.azMeritPassing[0]" ></cmps-progress-bar>
								<cmps-progress-bar value="passing_ELA" type="azmerit" label="ELA" :data="s2.data.azMeritPassing[0]" ></cmps-progress-bar>
							</div>
							<div class="statistics-block" v-if="s2.types.includes('high_school')">
								<h4><span>SAT Scores</span><span>{{ s2.data.satScores.length }} year average</span></h4>
								<cmps-progress-bar value="mathAvg" type="sat" label="Math" :avg="getSatMathAverage(s2)" :data="getSatMathAverage(s2)"></cmps-progress-bar>
								<cmps-progress-bar value="elaAvg" type="sat" label="ELA" :avg="getSatElaAverage(s2)" :data="getSatElaAverage(s2)"></cmps-progress-bar>
							</div>
							<div class="statistics-block" v-if="s2.types.includes('high_school')">
								<h4><span>ACT Average Composite Score</span><span>{{ s2.data.actScores.length }} year average</span></h4>
								<cmps-progress-bar value="avg" type="act" label="Avg Score" :avg="getActAverage(s2)" :data="getActAverage(s2)"></cmps-progress-bar>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="s1.features.length || s2.features.length" class="features">
				<header>
					<h3>School Programs</h3>
				</header>
				<div class="columns is-mobile is-centered">
					<div class="column is-5-tablet is-6-mobile">
						<div class="features-column" :style="{ backgroundColor: s1ColorTint }" v-if="s1.features">
							<div class="columns is-multiline">
								<div class="column is-6-widescreen is-12-tablet" v-for="category in categories" :key="category.id" v-if="hasAwards(category, s1.categories)">
									<h6>{{category.name}}</h6>
									<ul class="fa-ul" v-if="category.name !== 'Awards'">
										<li
											v-for="feature in category.features"
											:key="feature.id"
											:style="{
												color: hasFeature(feature, s1.features) ? '#432865' : '#f2f2f2',
												textDecoration: hasFeature(feature, s1.features) ? 'none' : 'line-through',
												textShadow: hasFeature(feature, s1.features) ? 'none' : '1px 1px 1px black'
											}">
											<span v-show="hasFeature(feature, s1.features) || hasFeature(feature, s2.features)"><i class="fa-li fa fa-check-circle"></i><span> {{feature.name}}</span></span>
										</li>
									</ul>
									<!-- 8/23/18 Request per Helen, if school doesn't have Awards don't grey out, instead don't display at all -->
									<ul class="fa-ul" v-else>
										<li
											v-for="feature in s1.features"
											:key="feature.id"
											:style="{
												display: hasFeature(feature, s1.features) ? 'list-item' : 'none',
												'color': '#432865'
											}">
											<i class="fa-li fa fa-check-circle"></i><span> {{feature.name}}</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div class="column is-5-tablet is-offset-2-tablet is-6-mobile is-offset-0-mobile">
						<div class="features-column" :style="{ backgroundColor: s2ColorTint }" v-if="s2.features">
							<div class="columns is-multiline">
								<div class="column is-6-widescreen is-12-tablet" v-for="category in categories" :key="category.id">
									<h6 ref="test">{{category.name}}</h6>
									<ul class="fa-ul" v-if="category.name !== 'Awards'">
										<li
											v-for="feature in category.features"
											:key="feature.id"
											:style="{
												color: hasFeature(feature, s2.features) ? '#432865' : '#f2f2f2',
												textDecoration: hasFeature(feature, s2.features) ? 'none' : 'line-through',
												textShadow: hasFeature(feature, s2.features) ? 'none' : '1px 1px 1px black'
											}">
											<span v-show="hasFeature(feature, s2.features) || hasFeature(feature, s1.features)"><i class="fa-li fa fa-check-circle"></i><span> {{feature.name}}</span></span>
										</li>
									</ul>
									<!-- 8/23/18 Request per Helen, if school doesn't have Awards don't grey out, instead don't display at all -->
									<ul class="fa-ul" v-else>
										<li
											v-for="feature in s2.features"
											:key="feature.id"
											:style="{
												display: hasFeature(feature, s2.features) ? 'list-item' : 'none',
												'color': '#432865'
											}">
											<i class="fa-li fa fa-check-circle"></i><span> {{feature.name}}</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
            <div v-else>No features</div>
					</div>
				</div> <!-- end columns is-mobile -->
			</div> <!-- end features -->

		</div> <!-- end container -->
	</div> <!-- end modal -->
</template>

<script>
	import ProgressBar from './ProgressBar.vue'
	import { DataFilter } from '../helpers/dataFilter.js'
	import { shadeColor } from '../helpers/functions.js'
	import ParentQualitySurvey from './accessibility/compare/PQStable.vue'
	import LetterGrade from './accessibility/compare/letterGradeTable.vue'
	import AzMerit from './accessibility/compare/AzMeritTable.vue'
	import SAT from './accessibility/compare/SATtable.vue'
	import ACT from './accessibility/compare/ACTtable.vue'
	import featuresTable from './accessibility/compare/featuresTable.vue'

	export default {
		components: {
			cmpsProgressBar: ProgressBar,
			cmpsAriaTablePqs: ParentQualitySurvey,
			cmpsAriaTableLetterGrade: LetterGrade,
			cmpsAriaTableAzMerit: AzMerit,
			cmpsAriaTableSat: SAT,
			cmpsAriaTableAct: ACT,
			cmpsAriaTableFeatures: featuresTable
		},
		computed: {

      isTranslateBarOpen() { return this.$store.state.main.translateBar.active },
			schools() { return this.$store.state.main.compare.schools },
			categories() { return this.$store.state.main.compare.categories },
			keys() { return this.$store.state.main.compare.keys },

			s1() {
				let school = this.schools[Object.keys(this.schools)[0]]
				if (school.data === undefined) {
					school.data = {}
				}
				return school
			},
			s2() {
				let school = this.schools[Object.keys(this.schools)[1]]
				if (school.data === undefined) {
					school.data = {}
				}
				return school
			},
			s1Data() { return new DataFilter(this.s1.data) },
			s2Data() { return new DataFilter(this.s2.data) },
			s1ColorTint() { return shadeColor(this.s1.color, 0.6) },
			s2ColorTint() { return shadeColor(this.s2.color, 0.6) }
		},
		methods: {

			hasFeature(feature, schoolFeatures) {
				let isIncluded = false
				schoolFeatures.forEach((f) => {
					if (feature.name === f.name) {
            isIncluded = true
          }
				})
				return isIncluded
			},
			hasAwards(category, schoolCategories) {
				if (category.name !== 'Awards') {
					return true
				}
				const categoryIDs = schoolCategories.map(c => c.id)
				return categoryIDs.includes(category.id)
			},
			handleScroll() {
				if (this.$refs.modal.scrollTop > 80) {
          this.$refs.header.classList.add('sticky')
          this.$refs.statistics.style.paddingTop = this.$refs.header.clientHeight + 1 - 25 + 'px' // need to add 1 for border and subtract 25 for top margin on statistics section
        } else {
          this.$refs.header.classList.remove('sticky')
          this.$refs.statistics.style.paddingTop = '0px'
        }
			},
			close() {
        this.$emit('close')
      },
      closeOnEscapeKeyup(event) {
        if (event.keyCode === 27) {
          this.close()
        }
      },
      onBackButtonPressed() {
        this.close()
      },
      getActAverage(school) {
        let actArray = []
          school.data.actScores.map(score => {
          actArray.push(score.avg_score)
        })
        let total = 0
        actArray.forEach(score => {
          total += score
        })
        let avg = total / actArray.length
        return avg
      },
      getSatMathAverage(school) {
        let mathArray = []
          school.data.satScores.map(score => {
          mathArray.push(score.math_avg)
        })
        let mathTotal = 0
        mathArray.forEach(score => {
          mathTotal += score
        })
        let mathAvg = mathTotal / mathArray.length
        return mathAvg
      },
      getSatElaAverage(school) {
        let elaArray = []
          school.data.satScores.map(score => {
          elaArray.push(score.rw_avg)
        })
        let elaTotal = 0
        elaArray.forEach(score => {
          elaTotal += score
        })
        let elaAvg = elaTotal / elaArray.length
        return elaAvg
      },
    },
		mounted() {
      let navbar = document.querySelector('.navbar')
      let footer = document.querySelector('footer')
      navbar.classList.add('display-none')
      footer.classList.add('display-none')
      document.documentElement.classList.add('disable-scrolling')
      window.addEventListener('popstate', this.onBackButtonPressed)
      window.addEventListener('keyup', this.closeOnEscapeKeyup)
      this.$refs.modal.addEventListener('scroll', this.handleScroll, { passive: true })
      this.$refs.modal.focus()
    },
    beforeDestroy() {
      let navbar = document.querySelector('.navbar')
      let footer = document.querySelector('footer')
      navbar.classList.remove('display-none')
      footer.classList.remove('display-none')
      document.documentElement.classList.remove('disable-scrolling')
      window.removeEventListener('popstate', this.onBackButtonPressed)
      window.removeEventListener('keyup', this.closeOnEscapeKeyup)
      this.$refs.modal.removeEventListener('scroll', this.handleScroll)
    },
	}
</script>

<style lang="scss" scoped>
	.modal.is-active {
    display: block;
    overflow-y: auto;
    background-color: white;
  }
  .modal-btn-close {
    margin-right: 20px;
    margin-left: 20px;
    cursor: pointer;
    color: white;
  }
  .modal-navbar {
  	background-color: #126;
  }
  .modal-navbar .container{
    display: flex;
    align-items: center;
    padding: 15px 0;
    h1 {
    	color: white;
      font-family: 'Montserrat', sans-serif;
      font-weight: 600;
      font-size: 1.75rem;
      font-weight: 600;
    }
  }

	.headings,
	.statistics,
	.features {
		margin-top: 25px;
		margin-bottom: 25px;
	}

	.headings {
		color: #fff;
		.flexbox {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: .75rem;
			height: 100%;
			box-shadow: 0px 3px 3px #000;
			img {
				// height: 115px;
			}
			.school-title {
				h1 {
					text-align: center;
					font-size: 1.5em;
					font-weight: 500;
					font-family: 'Montserrat', sans-serif;
				}
				h2 {
					text-align: center;
					font-size: 1em;
					font-weight: 400;
					font-family: 'Montserrat', sans-serif;
					margin-bottom: 15px;
				}
			}
		}
	}
	@media screen and (min-width: 1216px) {
		.headings .flexbox {
			flex-direction: row;
			justify-content: space-between;
			padding: 1rem;
			.school-title {
				h1 {
					font-size: 2em;
				}
				h2 {
					font-size: 1.5em;
				}
			}
		}
	}
	.headings.sticky {
		position: fixed;
		top: 0px;
		margin: 0;
		padding: 25px 0;
		border-bottom: 1px solid grey;
		width: 100%;
		background-color: white;
		z-index: 30;
		@media screen and (min-width: 1024px) {
			width: 960px;
		}
		@media screen and (min-width: 1216px) {
			width: 1152px;
		}
		@media screen and (min-width: 1408px) {
			width: 1344px;
		}
	}

	.statistics,
	.features {
		header {
			margin: 0 0 2.5rem 0;
		}
		h3 {
			font-size: 2rem;
			font-weight: 300;
			font-family: 'Montserrat', sans-serif;
			text-align: center;
			border-bottom: 1px solid grey;
		}
	}

	.stats-column,
	.features-column {
		padding: .75rem;
		height: 100%;
		box-shadow: 0px 3px 3px #000;
	}

	.statistics-block {
		margin-bottom: 4rem;
		h4 {
			font-family: 'Roboto', sans-serif;
			font-weight: 400;
			font-size: 1rem; //1.4
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
		}
	}

	.features {
		margin-bottom: 75px;
		h6 {
			font-size: 1.25rem; //1.65
			font-weight: 200;
			font-family: 'Roboto', sans-serif;
			margin-bottom: 10px;
		}
		ul li {
			font-size: 1rem; //1.25
		}
	}

	.columns.is-gapless > .column {
		margin-bottom: 2rem;
	}

	@media screen and (min-width: 1024px) {
		.statistics,
		.features {
			h3 {
				font-size: 3rem;
			}
		}
	}

	@media screen and (min-width: 1408px) {
		.statistics-block h4 {
			font-size: 1.4rem;
		}
		.features {
			h6 {
				font-size: 1.4rem;
			}
			ul li {
				font-size: 1.2rem;
			}
		}
	}
</style>
